/**
 * 任务历史记录请求参数
 */
export interface TaskHistoryRequest {
    /**
     * 任务 ID
     */
    task_id: string;
}

/**
 * 步骤内容（动态类型）
 */
export type StepContent = Record<string, any>;

/**
 * 任务步骤
 */
export interface TaskStep {
    /**
     * 步骤类型
     */
    step_type: string;
    /**
     * 步骤名称
     */
    step_name: string;
    /**
     * 步骤内容
     */
    content: StepContent;
    /**
     * 方向
     */
    direction: 'input' | 'output';
    /**
     * 是否隐藏
     */
    hide: boolean;
    /**
     * 创建时间
     */
    created_at: number;
    /**
     * 更新时间
     */
    updated_at: number;
}

/**
 * 任务历史记录响应
 */
export interface TaskHistoryResponse {
    /**
     * 请求状态
     */
    status: boolean;
    /**
     * 错误代码
     */
    error_code: number;
    /**
     * 错误消息
     */
    error_msg?: string;
    /**
     * 响应数据
     */
    data?: {
        /**
         * 任务 ID
         */
        task_id: string;
        /**
         * 任务类型
         */
        task_type: string;
        /**
         * 步骤列表
         */
        steps: TaskStep[];
    };
}

/**
 * `/task/history` 用于入口分流时返回的最小步骤结构。
 * 当前真实接口使用 snake_case，保留 camelCase 以兼容交接文档及可能的网关转换。
 */
export interface TaskRoutingHistoryStep {
    step_type?: string;
    stepType?: string;
}

/** `/history` 中转页识别单篇/批量任务所需的接口响应。 */
export interface TaskRoutingHistoryResponse {
    status?: boolean;
    error_code?: number;
    error_msg?: string;
    data?: {
        task_id?: string;
        taskId?: string;
        steps: TaskRoutingHistoryStep[];
    };
}

export const TaskHistoryApi = Symbol('TaskHistoryApi');

/**
 * 任务历史记录 API
 */
export interface TaskHistoryApi {
    /**
     * 获取任务历史记录
     */
    getTaskHistory(request: TaskHistoryRequest): Promise<TaskHistoryResponse>;

    /** 通过任务步骤识别任务是否属于批量流程。 */
    getTaskRoutingHistory(
        request: TaskHistoryRequest
    ): Promise<TaskRoutingHistoryResponse>;
}
